import { gql } from '../../../../__generated__/graphql/catalog'

export const FORGOT_PASSWORD = gql(`
  mutation customerForgotPassword($email: String!) {
    customerForgotPassword(email: $email)
  }
`)
